import { render, staticRenderFns } from "./DiscountedWillWritingForReferralCard.vue?vue&type=template&id=58b2e59a"
import script from "./DiscountedWillWritingForReferralCard.vue?vue&type=script&lang=js"
export * from "./DiscountedWillWritingForReferralCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports